import React, { useEffect, useState } from "react";
import Strings from "@my-dld/assets/strings";
import { PetInfo } from "@eres/ejari-api/Entity/co_occupants";
import { EjariApi } from "@eres/ejari-api";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import { LocaleUtil } from "@eres/core";

interface Props {
	contractType?: number;
	contractId?: number;
}

export function Pets( props: Props ) {
	let { contractId, contractType } = props;
	const [ pets, setPets ] = useState<PetInfo[]>( [] );
	useEffect( () => {
		if ( contractId == null || contractType == null ) return;
		EjariApi.getPets( contractId, contractType )
		.then( setPets )
		.catch( showErrorMessage );
	}, [ contractId, contractType ] );
	if ( pets.length === 0 ) return null;
	return <>
		<div className="" id="occupantListDetail">
			<div className="section-title justify-content-between">
				<h5>{ Strings.pets }</h5>
			</div>
			<table className="table table-bordered table-striped font-size14">
				<PetsHeader/>
				<tbody>
				{ pets.map( ( value, index ) =>
					<PetsRow index={ index } data={ value } key={ index }/> )
				}
				</tbody>
			</table>
		</div>
	</>;
}

export function PetsRow( props: React.PropsWithChildren<{ index: number, data: PetInfo }> ) {
	let { data, index, children } = props;
	return <tr>
		<td data-label={ Strings.sr_no }>{ index + 1 }</td>
		<td data-label={ Strings.pet_type }>{ LocaleUtil.getLocalValue( data ) }</td>
		<td data-label={ Strings.pet_count }>{ data.Count + "" }</td>
		{ children }
	</tr>;
}

export function PetsHeader( props: React.PropsWithChildren<any> ) {
	return ( <thead>
	<tr>
		<th style={ { width: 70 } }>{ Strings.sr_no }</th>
		<th>{ Strings.pet_type }</th>
		<th>{ Strings.pet_count }</th>
		{ props.children }
	</tr>
	</thead> );
}
